import { useTranslation } from 'react-i18next';
import type { ISubDocument } from '@interfaces/ISubcontractorPortal';
import { DocumentIcon } from '@utils/icons';
import { formatShortDate } from '../subcontractors.format';
import styles from './DocumentsList.module.css';

export function DocumentsList({ documents, tz }: { documents: ISubDocument[]; tz: string }) {
  const { t } = useTranslation();
  return (
    <section className={styles.panel}>
      <header className={styles.head}>
        <h3 className={styles.title}>{t('subcontractors.documents.title')}</h3>
        <span className={styles.count}>
          {t('subcontractors.documents.count', { count: documents.length })}
        </span>
      </header>
      <ul className={styles.grid}>
        {documents.map((d) => (
          <li key={d.id} className={styles.card}>
            <div className={styles.icon} aria-hidden="true">
              <DocumentIcon size={18} />
            </div>
            <div className={styles.body}>
              <div className={styles.codeRow}>
                <span className={styles.code}>{d.code}</span>
                {d.isNew ? (
                  <span className={styles.newPill}>
                    {t('subcontractors.documents.new')}
                  </span>
                ) : null}
              </div>
              <span className={styles.docTitle}>{d.title}</span>
              <span className={styles.meta}>
                {d.revision} · {formatShortDate(d.date, tz)}
              </span>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
